var React = require('react');

function StepCircle0548px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M24 46C11.85 46 2 36.15 2 24S11.85 2 24 2s22 9.85 22 22-9.85 22-22 22m0-46C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0m4.589 15.1h-8.086l-1.092 8.112a14.108 14.108 0 0 1 2.366-.182c3.354 0 4.836 1.56 4.836 3.718.026 2.288-1.846 3.692-3.978 3.692-1.56 0-2.938-.52-3.64-.936l-.572 1.742c.832.52 2.366 1.04 4.212 1.04 3.666 0 6.292-2.47 6.292-5.772 0-2.132-1.092-3.614-2.418-4.342-1.04-.624-2.314-.91-3.64-.91-.624 0-.988.052-1.378.104l.65-4.342h6.448V15.1z"}));
}

StepCircle0548px.displayName = "StepCircle0548px";

StepCircle0548px.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = StepCircle0548px;

StepCircle0548px.default = StepCircle0548px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/step-circle-05-48px.svg
// module id = 1156
// module chunks = 0